<footer>
    <span> {{year}} © {{ copyright }} </span>
    <span>
        <span [title]="appVersion">version: {{ appVersion }} </span>
        <img *ngIf="!hideICC" src="assets/IC-COMPLEX-footer.svg" alt="IC COMPLEX">
    </span>
</footer>
